import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { usersApi } from '@/api/endpoints'
import { keys } from '@/api/keys'
import type { Preferences, PreferencesPatch } from '@/api/types'
import { useToast } from '@/components/ui/Toast'
import { useT } from '@/i18n'

export function usePreferences() {
  return useQuery({ queryKey: keys.preferences(), queryFn: usersApi.preferences })
}

/** 开关类设置用乐观更新：点下去立刻变，失败了再弹回来。 */
export function useUpdatePreferences() {
  const t = useT()
  const client = useQueryClient()
  const toast = useToast()
  return useMutation({
    mutationFn: (patch: PreferencesPatch) => usersApi.updatePreferences(patch),
    onMutate: async (patch) => {
      await client.cancelQueries({ queryKey: keys.preferences() })
      const previous = client.getQueryData<Preferences>(keys.preferences())
      if (previous) {
        client.setQueryData<Preferences>(keys.preferences(), {
          ...previous,
          notifications: { ...previous.notifications, ...patch.notifications },
          notify_following_only: patch.notify_following_only ?? previous.notify_following_only,
          language: patch.language ?? previous.language,
        })
      }
      return { previous }
    },
    onError: (_error, _patch, context) => {
      if (context?.previous) client.setQueryData(keys.preferences(), context.previous)
      toast.error(t('toast.saveFailed'))
    },
    onSuccess: (prefs) => client.setQueryData(keys.preferences(), prefs),
  })
}
